// frontend/admin-portal/src/services/categoryService.js
import api from './axiosConfig';

export const categoryService = {
    list: async (params = {}) => {
        const { data } = await api.get('/categories', { params });
        return data.data.categories;
    },
    get: async (idOrSlug) => {
        const { data } = await api.get(`/categories/${idOrSlug}`);
        return data.data.category;
    },
    create: async (payload) => {
        const { data } = await api.post('/categories', payload);
        return data.data.category;
    },
    update: async (id, payload) => {
        const { data } = await api.put(`/categories/${id}`, payload);
        return data.data.category;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/categories/${id}`);
        return data;
    },
};